const config = {
    isSocialMediaLinksEnabled: false,
    isAdditionalLinksEnabled: false,
    deployedBaseUrl: window.location.href
}

export default config;